<template>
  <div class="energy-trends">
    <div class="energy-trends-title">制冷用能同比</div>
    <div class="energy-trends-data">
      <div class="data-table">
        <div class="energy-trends-condition">
          <div class="item">
            <span class="title">类型</span>
            <el-select v-model="type" :clearable="clearableFlag" placeholder="请选择" @change="queryMonthTrends">
              <el-option v-for="item in typeArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column prop="deviceName" label="机组名称"></el-table-column>
          <el-table-column prop="toDayData" label="当期用能(kwh)"></el-table-column>
          <el-table-column prop="beforeData" label="上期用能(kwh)"></el-table-column>
          <el-table-column prop="addValue" label="增加值"></el-table-column>
          <el-table-column label="同比值(%)">
            <template slot-scope="scope">
              <span>{{scope.row.chainValue}}</span>
              <span v-if="scope.row.addValue > 0" style="font-size: 26px; margin-left: 3px; color: red;">⬆</span>
              <span v-if="scope.row.addValue < 0" style="font-size: 26px; margin-left: 3px; color: #12CE6C;">⬇</span>
            </template>
          </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="data-chart">
        <div id="energyYearChart" style="width: 100%; height: 12rem"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '../api/api'
import eCharts from "echarts"
export default {
  data() {
    return {
      clearableFlag: false,
      type: '2',
      typeArr: [{ 'label': '月', 'value': '2' }, { 'label': '年', 'value': '3' }],
      tableData: [],
      energyYearChart: null,
      energyChartOpt: {}
    }
  },
  mounted() {
    this.queryMonthTrends()
    window.onresize = () => {
      this.energyYearChart.resize()
    }
  },
  methods: {
    async queryMonthTrends() {
      this.xData = []
      this.yDataA = []
      this.yDataB = []
      const {
        success,
        returnObj
      } = await this.$fetch(api.queryEnergyTongBi + '?dateType=' + this.type)
      if (success && returnObj.length > 0) {
        this.tableData = returnObj
        for (let i = 0; i < returnObj.length; i++) {
          this.xData.push(returnObj[i].deviceName)
          this.yDataA.push(returnObj[i].toDayData)
          this.yDataB.push(returnObj[i].beforeData)
        }
        this.initChart()
      }
    },
    initChart() {
      let chartDom = document.getElementById("energyYearChart");
      this.energyYearChart = eCharts.init(chartDom);
      this.energyChartOpt = {
        color: ['#00BFFF', '#12CE6C'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          icon: "rect",
          itemHeight: 12,
          itemWidth: 25,
          right: 20,
          top: 10
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '6%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          },
          axisLabel: {
            interval: 0,//横轴信息全部显示
            // rotate: -50,// -20度角倾斜显示
          },
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          name: "单位：kwh",
        },
        series: [
          {
            name: '当期',
            type: 'bar',
            data: this.yDataA
          },
          {
            name: '上期',
            type: 'bar',
            data: this.yDataB
          }
        ]
      };
      this.energyYearChart.setOption(this.energyChartOpt);
    },
  }
}
</script>

<style lang="scss" scoped>
.energy-trends {
  width: 100%;
  height: 100%;
}

.energy-trends-title {
  margin: 15px 0 0 10px;
  font-size: 16px;
  font-weight: bold;
}

.energy-trends-condition {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 0;

  .item {
    margin-right: 10px;

    .title {
      margin-right: 10px;
    }
  }
}

.energy-trends-data {
  margin: 12px;
  display: flex;
  justify-content: space-between;

  .data-table {
    width: 66%;
  }

  .data-chart {
    width: 34%;
  }
}
</style>